<template>
  <footer class="d-print-none">
    <img
      v-if="$federation.isFinlandEquestrian"
      class="federation-fi-background"
      alt=""
      role="img"
      aria-hidden="true"
      :src="$federation.logo.image"
    />

    <div
      v-else-if="$federation.isNorwayEquestrian"
      class="federation-no-background"
      :style="`background-image: url(${$federation.images.footer})`"
    />

    <AccessabilityPanel v-model="accessability" />
    <v-container style="position: relative">
      <v-row>
        <v-col md="8" class="pr-1">
          <div class="white--text">
            {{ $t("navigation:footer.Address.Line1") }}
            <br />
            {{ $t("navigation:footer.Address.Line2") }}<br />
            {{ $t("navigation:footer.Address.Line3") }}
            <br />
            {{ $t("navigation:footer.Address.Line4") }}<br />
            <br />
            {{ $t("navigation:footer.Address.Line5") }}<br />
            {{ $t("navigation:footer.Address.Line6") }}<br />
          </div>
        </v-col>
        <v-col md="4" class="pr-1">
          <div class="text-right">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                  min-width="10px"
                  color="accessability black--text"
                  class="px-2"
                  :aria-label="$t('navigation:AccessibilityMenu.button.alt')"
                  v-bind="attrs"
                  v-on="on"
                  @click="() => (accessability = true)"
                >
                  <v-icon>$iconA18yIcon</v-icon>
                </v-btn>
              </template>
              <span>{{
                $t("navigation:AccessibilityMenu.button.tooltip")
              }}</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>
<script>
import { defineComponent, ref } from "vue";
import AccessabilityPanel from "@elements/AccessabilityPanel.vue";

export default defineComponent({
  name: "AppFooter",
  components: {
    AccessabilityPanel
  },
  setup() {
    const accessability = ref(false);
    return { accessability };
  }
});
</script>
<style lang="scss" scoped>
footer {
  align-self: end;

  background-color: var(--v-footer-base);
  height: 300px;
  max-height: 300px;
  padding: 2em 1.5em;
  position: relative;
  overflow: hidden;
  width: 100%;

  .federation-fi-background {
    pointer-events: none;
    opacity: 0.03;
    transform: rotate(20deg);
    position: absolute;
    width: 90%;
    top: -50%;
    right: -30%;
    z-index: 0;
    @media (max-width: 768px) {
      display: none;
    }
  }
  .federation-no-background {
    background-image: url("../federations/NO/footer-image.svg");
    background-repeat: repeat-x;
    background-position: center;

    height: 100%;
    width: 100%;

    position: absolute;
    left: 0;
    top: 0;

    filter: invert(90%);
  }
}
</style>
